import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiService } from '../../../../portal/src/app/service/api.service';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../portal/src/app/material-module';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from "../../../../website/src/app/shared/shared.module";

@Component({
  selector: 'app-rate-request-dialog',
  standalone: true,
  templateUrl: './rate-request-dialog.component.html',
  styleUrl: './rate-request-dialog.component.css',
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, SharedModule]
})
export class RateRequestDialogComponent {
  @Input() inputObj: any;
  @Input() type: any;
  // @Input() getObj: any;
  @Output() closeEmit = new EventEmitter<void>();
  @Output() event = new EventEmitter<any>();
  remarks: any;
  rateRequestInfo: any;
  dialogRef: any;
  id: any;
  isLoading: boolean = false;
  constructor(private portalApiService: ApiService,
    private route: Router, private router: ActivatedRoute,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    // console.log(this.inputObj)
    // console.log(this.type);
  }

  submitRateRequest(confirmTemapletDialog) {

    let obj=<any>{};
    Object.assign(obj, this.inputObj);
    obj["remarks"] = this.remarks;
    obj["from"] = this.inputObj.from.id;
    obj["to"] = this.inputObj.to.id;
    obj["liners"] = <any>null;
    obj["containers"] =<any>null;
    obj["vessel_name"]= !!this.inputObj.vessel_name && !!this.inputObj.vessel_name.id ? this.inputObj.vessel_name : null

    if (!!this.inputObj.liners) {
      let id = <any>[];
      this.inputObj.liners.forEach(i => {
        id.push(i.id);
      })
      obj.liners = id + '';
    }

    if (!!this.inputObj.containers) {
      let id = <any>[];
      this.inputObj.containers.forEach(i => {
        id.push(i.id);
      })
      obj.containers = id + '';
    }
    this.isLoading = true;
    this.portalApiService.createRateRequest(obj).subscribe(res => {
      if (res.statusCode == 201) {
        this.rateRequestInfo = res.info;
        this.isLoading = false;
        this.event.emit({ id: this.rateRequestInfo.id, close: true });
        this.close();
        this.dialogRef = this.dialog.open(confirmTemapletDialog, {
          width: '500px'
        });
      }
    })
  }

  close() {
    this.closeEmit.emit();
    if (this.type == 'website') {
      this.event.emit({ id: this.rateRequestInfo, close: true });
    }
  }

  openRequest() {
    this.dialogRef.close();
    if (this.type != 'website') {
      this.route.navigate(['main/rates/rate-request/id'], { queryParams: { selectedId: this.rateRequestInfo.id } });
    } else {
      let token = localStorage.getItem("x-token");
      let url = "https://app.atmavaan.com/redirect?token=" + encodeURIComponent(token || '') + "&url=main/rates/rate-request/all";
      window.open(url, "_self");
    }
  }

}
